import { cn } from "@/shared/utils/cn";
import "./froppioLoader.css";

const SKIN = "#B8E986";
const INK = "#254B32";
const EYE = "#FFFEF5";

interface FroppioLoaderProps {
  className?: string;
}

export function FroppioLoader({ className }: FroppioLoaderProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 100 110"
      fill="none"
      className={cn("froppio-loader size-16", className)}
    >
      <ellipse className="froppio-loader__shadow" cx="50" cy="99" rx="26" ry="3.5" fill={INK} opacity="0.18" />
      <g className="froppio-loader__frog" stroke={INK} strokeWidth="1.6" strokeLinejoin="round">
        <g className="froppio-loader__feet" fill={SKIN}>
          <ellipse cx="31" cy="91.5" rx="10" ry="4" />
          <ellipse cx="69" cy="91.5" rx="10" ry="4" />
        </g>
        <g transform="translate(16.4 40) scale(0.4) translate(-62 -48)">
          <path
            d="M67 99c-2-29 10-49 31-49 17 0 27 10 32 21h22c5-11 15-21 32-21 21 0 33 20 31 49 7 8 11 19 9 31-4 26-31 41-83 41s-79-15-83-41c-2-12 2-23 9-31z"
            fill={SKIN}
            strokeWidth="4"
          />
          <g className="froppio-loader__eyes">
            <ellipse cx="104" cy="91" rx="17" ry="20" fill={EYE} stroke="none" />
            <ellipse cx="179" cy="91" rx="17" ry="20" fill={EYE} stroke="none" />
            <path d="M97 94c2-7 10-7 13 0m62 0c2-7 10-7 13 0" strokeWidth="5" strokeLinecap="round" />
          </g>
          <path d="M120 126q21 29 42 0z" fill={INK} stroke="none" />
        </g>
      </g>
    </svg>
  );
}
